import BaseAPI from "../api";

const path_front: string = "complaints-front";
const path_back: string = "complaints-back";

export type complaintListFront = {
    keyword?: string;
    id_complaints_type?: number;
    start_date?: string;
    end_date?: string;
    complaints_status?: string;
    limit?: number;
    page?: number;
}
export type complaintCreateFront = {
    id_complaints_type: number;
    complaints_date: Date | string | null;
    complaints_subject: string;
    complaints_desc: string;
    is_public: boolean,
    first_name: string;
    last_name: string;
    student_no: string;
    passport: string;
    id_faculty: number | null;
    phone: string;
    email: string;
    // id_position: number | null;
}
export type updateStatusBack = {
    complaints_status: string;
    complaints_result: string;
}
export type type_complaint_status = {
    complaints_status: string;
}

export type logComplaintType = {
    keyword?: string;
    limit?: number;
    page?: number;
}
export type meetingComplaints = {
    keyword?: string;
    page?: number;
    limit?: number;
}

export class ComplaintApi extends BaseAPI {
    // FRONT
    static getListFront(query: complaintListFront): Promise<any> {
        return this.api.get(`${path_front}`, {
            params: { ...query }
        })
    }
    static createFront(body: complaintCreateFront): Promise<any> {
        return this.api.post(`${path_front}`, body)
    }
    static updateStatus(id_complaints: number, body: type_complaint_status): Promise<any> {
        return this.api.patch(`${path_front}/status/${id_complaints}`, body)
    }
    static getOne(id_complaints: number): Promise<any> {
        return this.api.get(`${path_front}/${id_complaints}`)
    }
    static updateOne(id_complaints: number, body: complaintCreateFront): Promise<any> {
        return this.api.patch(`${path_front}/${id_complaints}`, body)
    }
    static uploadFile(file: FormData): Promise<any> {
        return this.api.post(`${path_front}/file`, file, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
    static deleteFile(id_complaints_file: number): Promise<any> {
        return this.api.delete(`${path_front}/file/${id_complaints_file}`)
    }
    static downloadFile(id_complaints_file: number): Promise<any> {
        return this.api.get(`${path_front}/file/${id_complaints_file}`, {
            responseType: 'blob'
        })
    }



    // BACK
    static getDetailBack(id_complaints: number): Promise<any> {
        return this.api.get(`${path_back}/${id_complaints}`)
    }
    static getListBack(query: complaintListFront): Promise<any> {
        return this.api.get(`${path_back}`, { params: { ...query } })
    }
    static updateStatusBack(id_complaints: number, body: updateStatusBack): Promise<any> {
        return this.api.patch(`${path_back}/status/${id_complaints}`, body)
    }

    static getLog(id_complaints: number, query: logComplaintType): Promise<any> {
        return this.api.get(`${path_back}/${id_complaints}/log`, { params: { ...query } })
    }
    static getMeetingList(id_complaints: number, query: meetingComplaints): Promise<any> {
        return this.api.get(`${path_back}/${id_complaints}/meeting`, { params: { ...query } })
    }

}